var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRejectedCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z",
    fill: "#DC2626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2444 14.1214L14.1244 12.0014L16.2444 9.88144C17.6044 8.44644 15.5594 6.39644 14.1244 7.76144L12.0044 9.88144L9.88439 7.76144C9.29939 7.17644 8.34939 7.17644 7.76439 7.76144C7.17939 8.34644 7.17939 9.29644 7.76439 9.88144L9.87939 12.0014L7.75939 14.1214C6.39939 15.5564 8.44439 17.6064 9.87939 16.2414L11.9994 14.1214L14.1194 16.2414C15.5544 17.6014 17.6044 15.5614 16.2444 14.1214Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedCircle);
export default __webpack_public_path__ + "static/media/rejected-circle.854617df.svg";
export { ForwardRef as ReactComponent };